import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { ForexDerivativesService } from 'src/app/service/forex-derivatives.service';
import { RateDerivativesService } from 'src/app/service/rate-derivatives.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
declare var $: any;

@Component({
  selector: 'app-fixed-interest',
  templateUrl: './fixed-interest.component.html',
  styleUrls: ['./fixed-interest.component.css'],
  viewProviders: [{
    provide: ControlContainer, useExisting: FormGroupDirective
  }]
})
export class FixedInterestComponent implements OnInit, OnChanges {

  fixedInterestPayRecForm: FormGroup;
  paymentFreqList: any = ['1M', '2M', '3M', '6M', '12M', 'BULLET'];
  dayCountFractionList: any = ['ACT/ACT', 'ACT/360', '30/360', '30/365', 'ACT/365'];
  fixedInterestFormGroupName: string;
  config: any = config;
  currencyList: any = [];
  bsValue: any = [];
  paymentData: any = [];
  recouponingDtls: any = [];

  @Input() swapType: String;
  @Input() interestPayRec: string;
  @Input() irsFormData: any = {};
  @Input() action: string;
  @Output() formUpdateInt = new EventEmitter<{ formData: FormGroup, interestPayRec: string }>();

  constructor(private fb: FormBuilder,
    private userDetailsService: UserDetailsService,
    private cdref: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private fgd: FormGroupDirective,
    private forexService: ForexDerivativesService,
    private toastr: ToastrService,
    private rateService: RateDerivativesService) { }

  ngOnInit(): void {

    // this.fixedInterestPayRecForm = this.fb.group({
    //   backwrdEffDateFlg: ['N', Validators.required],
    //   fixedRate: ['', Validators.required],
    //   effectiveDate: ['', Validators.required],
    //   recouponingFlag: ['N', Validators.required],
    //   recouponingRepetitions: [0, Validators.required],
    //   stub: ['N', Validators.required],
    //   dayCountFraction: ['', Validators.required],
    //   noOfRepetition: ['', Validators.required],
    //   paymentFreqncy: ['', Validators.required],
    //   fixedPaymentSchedule: this.fb.array([])
    // });
    // this.fgd.form.addControl('fixedInterest', this.fixedInterestPayRecForm);

  }

  ngOnChanges(changes: SimpleChanges): void {
    let intData;
    if (this.swapType == 'FXFL' || (this.swapType == 'FXFX' && this.interestPayRec == 'pay')) {
      intData = this.irsFormData?.fixedInterestPayable || null;
      this.fixedInterestFormGroupName = 'fixedInterestPayable';
    } else if (this.swapType == 'FLFX' || (this.swapType == 'FXFX' && this.interestPayRec == 'receive')) {
      intData = this.irsFormData?.fixedInterestReceivable || null;
      this.fixedInterestFormGroupName = 'fixedInterestReceivable';
    }
    this.fixedInterestPayRecForm = this.fb.group({
      backwrdEffDateFlg: [intData?.backwrdEffDateFlg || 'N', Validators.required],
      fixedRate: [intData?.fixedRate || '', Validators.required],
      effectiveDate: [intData?.effectiveDate ? new Date(intData?.effectiveDate) : '', Validators.required],
      recouponingFlag: [intData?.recouponingFlag || 'N', Validators.required],
      recouponingRepetitions: [intData?.recouponingRepetitions || 0, Validators.required],
      stub: [intData?.stub || 'N', Validators.required],
      dayCntFrctn: [intData?.dayCntFrctn || '', Validators.required],
      noOfRepetition: [intData?.noOfRepetition || '', Validators.required],
      paymentFreqncy: [intData?.paymentFreqncy || '', Validators.required],
      firstPaymentDate: [intData?.firstPaymentDate ? new Date(intData?.firstPaymentDate) : ''],
      recouponingDtls: this.fb.array([]),
      fixedPaymentSchedule: this.fb.array([])
    });


    if (this.swapType == 'FXFL' || (this.swapType == 'FXFX' && this.interestPayRec == 'pay')) {
      this.fixedInterestPayRecForm.controls.intrstFxPaybleId = this.fb.control(intData?.intrstFxPaybleId);
      this.fgd.form.controls.fixedInterestPayable = this.fixedInterestPayRecForm;
      this.fgd.form.controls.floatInterestPayable = this.fb.group({});
      this.fgd.form.controls.floatInterestPayable.updateValueAndValidity();
      this.fgd.form.controls.fixedInterestPayable.updateValueAndValidity();
    } else if (this.swapType == 'FLFX' || (this.swapType == 'FXFX' && this.interestPayRec == 'receive')) {
      this.fixedInterestPayRecForm.controls.intrstFxRecId = this.fb.control(intData?.intrstFxRecId);
      this.fgd.form.controls.fixedInterestReceivable = this.fixedInterestPayRecForm;
      this.fgd.form.controls.floatInterestReceivable = this.fb.group({});
      this.fgd.form.controls.floatInterestReceivable.updateValueAndValidity();
      this.fgd.form.controls.fixedInterestReceivable.updateValueAndValidity();
    }
    this.paymentData = this.irsFormData[this.fixedInterestFormGroupName]?.fixedPaymentSchedule;
    this.recouponingDtls = this.irsFormData[this.fixedInterestFormGroupName]?.recouponingDtls;
    if (this.action == 'reversal' || this.action == 'view') {
      this.fixedInterestPayRecForm.disable();
    }
    this.fgd.form.updateValueAndValidity();
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  get f() { return this.fixedInterestPayRecForm.controls; }

  reset() {
    this.fixedInterestPayRecForm.reset();
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  onSubmit() {
    this.formUpdateInt.emit({ formData: <FormGroup>this.fixedInterestPayRecForm, interestPayRec: this.interestPayRec });
  }

  formUpdate(event: { formData: FormArray }) {
    if (this.fixedInterestFormGroupName == 'fixedInterestPayable') {
      this.fgd.form.controls.fixedInterestPayable['controls'].fixedPaymentSchedule = event.formData;
      this.fgd.form.controls.fixedInterestPayable.updateValueAndValidity();
      if ((<FormArray>this.fgd.form.controls.fixedInterestPayable['controls'].fixedPaymentSchedule).controls.length > parseInt(this.f.noOfRepetition.value)) {
        this.toastr.warning("Payment schedule not exceed number of repetitions")
      }
    } else if (this.fixedInterestFormGroupName == 'fixedInterestReceivable') {
      this.fgd.form.controls.fixedInterestReceivable['controls'].fixedPaymentSchedule = event.formData;
      this.fgd.form.controls.fixedInterestReceivable.updateValueAndValidity();
      if ((<FormArray>this.fgd.form.controls.fixedInterestReceivable['controls'].fixedPaymentSchedule).controls.length > parseInt(this.f.noOfRepetition.value)) {
        this.toastr.warning("Payment schedule not exceed number of repetitions")
      }
    }
    this.fixedInterestPayRecForm.controls.fixedPaymentSchedule = event.formData;
    this.fixedInterestPayRecForm.controls.fixedPaymentSchedule.updateValueAndValidity();
    this.fixedInterestPayRecForm.updateValueAndValidity();
    this.fgd.form.updateValueAndValidity();
    this.cdref.detectChanges();
    this.onSubmit();
  }

  recouponFormUpdate(event: { formData: FormArray }) {
    this.fgd.form.controls.fixedInterestPayable['controls'].recouponingDtls = event.formData;
    this.fgd.form.controls.fixedInterestPayable.updateValueAndValidity();
    this.fixedInterestPayRecForm.controls.recouponingDtls = event.formData;
    this.fixedInterestPayRecForm.controls.recouponingDtls.updateValueAndValidity();
    this.fixedInterestPayRecForm.updateValueAndValidity();
    this.fgd.form.updateValueAndValidity();
    this.cdref.detectChanges();
  }

  getPaymentSchedule() {
    if (this.f.effectiveDate.value && this.f.noOfRepetition.value && this.f.paymentFreqncy.value && this.fgd.form.controls.crncyImpctHoliday.value) {
      let requestObject = {
        "startDate": this.f.effectiveDate.value,
        "repetitions": this.f.noOfRepetition.value,
        "frequency": this.f.paymentFreqncy.value,
        "crncyImpctHoliday": this.fgd.form.controls.crncyImpctHoliday.value?.toString() || ''
      }
      this.rateService.getPaymentSchedule(requestObject).pipe(
        catchError((error: any) => {
          this.toastr.error(this.config.failureResponse["SOMETHING_WENT_WRONG"]);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.irsFormData[this.fixedInterestFormGroupName].fixedPaymentSchedule = response.data;
          this.paymentData = response.data;
          this.cdref.detectChanges();
        } else {
          this.toastr.error(response.message);
        }
      })
    }
  }

  getRecouponingSchedule() {
    if (this.f.recouponingRepetitions.value) {
      let recouponingArray: any = [];
      for (var i = 0; i < this.f.recouponingRepetitions.value; i++) {
        recouponingArray.push({ 'recouponingDate': '', 'recouponingRate': '' });
      }
      this.irsFormData[this.fixedInterestFormGroupName].recouponingDtls = recouponingArray;
      this.recouponingDtls = recouponingArray;
    }
  }

  stubChange() {
    if (this.f.stub.value == 'Y') {
      this.f.firstPaymentDate.addValidators(Validators.required);
    } else {
      this.f.firstPaymentDate.removeValidators(Validators.required);
    }
    this.f.firstPaymentDate.updateValueAndValidity();
  }
}
